export const names = {
  Login: "تسجيل الدخول",
  Home: "الصفحة الرئيسية",
  Users: "المستخدمين",
  Banks: "البنوك",
  Cars: "السيارات",
  Clients: "العملاء",
  Employee: "العملاء",
  Groups: "المجموعات",
  Importers: "الموردين",
  Items: "الاصناف",
  Jobs: "الوظائف",
  OfferItems: "عروض الموبايل",
  Regions: "المناطق",
  Money: "المصاريف",
  SadadStatus: "حالات السداد",
  Khazina: "الخزائن",
  SadadTypes: "انواع السدادات",
  Stores: "المخازن",
  Employers: "الموظفين",
  Branches: "الفروع",
  ClientUsers: "مستخدمين العملاء",
  BuyFatwora: "فاتورة شراء",
  BuyFatworaReback: "فاتورة مرتجع شراء",
  BuyFatworaConfirmation: "تأكيد فاتورة الشراء",
  SellFatwora: "فاتورة مبيعات",
  SellFatworaReback: "مرتجع فاتورة مبيعات",
  PublicRebackFatwora: "فاتورة مرتجع عام ",
  TanfizFatworas: "قواتير قيد التنفيذ",
  SarfFromStore: "فواتير قيد الصرف من المخزن",
  TaslimFatworas: "فواتير قيد التسليم",
  SolmtFatworas: "فواتير قيد استلام العميل",
  FatworaDetailByID: "طباعة فاتورة مبيعات ",
  FatworaDetailByIDStore: "طباعة فاتورة مبيعات",
  FatworaRebackDetailByID: "كباعة فاتورة مرتجع",
  Rebackfatworas: "فواتير المرتجعات",
  FinalFatworas: "الفواتير النهائية",
  OrderConfirmation: "صفحة المشرف ",
  StoreTransfer: "تحويل المخازن",
  StoreTransferFrom: "فواتير تحويلات مخازن من",
  StoreTransferTo: "فواتير تحويلات مخازن الي",
  StoreTransferFatworas: "فواتير التحويلات",
  SanfCard: "كارت صنف",
  StoreGard: "جرد مخازن",
  EmployerStore: "ربط موظفين بالمخزن",
  StoreItemStart: "بداية رصيد للاصناف",
  ClientSadad: "سداد عملاء",
  ImporterSadad: "سداد موردين",
  ClientKhasm: "خصم عملاء",
  Deposit: "ايداع",
  Withdrew: "سحب",
  KhaznaTransfer: "تحويل خزنة لخزنة اخري",
  Masrofat: "المصروفات",
  Ohda: "العهدة",
  BankCheque: "الشيكات",
  BankDeposite: "ايداع بنك",
  BankTransfer: "تحويل بنك",
  BankWithdrew: "سحب بنك",
  EmployersOmola: "عمولة موظفين",
  EmployerBadalat: "بدلات موظفين",
  EmployerHafez: "حوافز موظفين",
  EmployerKhasm: "خصم موظفين",
  EmployerSolfa: "سلف موظفين",
  SalaryInput: "المرتبات والحوافز",
  Vacancy: "الاجازات",
  EmployerSalary: "مرتبات الموظفين",
  Events: "الاحداث",
  Attends: "الحضور والانصراف",
  Tracking: "التتبع",
  Chat: "الرسائل",
  MandobTargetInput: "تحديد تارجت مندوبين",
  ClientDetailAccount: "كشف حساب عميل مفصل",
  ClientAccount: "كشف حساب عميل مختصر",
  ImporterAccount: "كشف حساب مورد",
  MandobClientTypeReport: "تقرير مندوب بنوع العميل",
  MandobItemReport: "تقرير مندوب بنوع الصنف",
  MandobTarget: "تارجت مندوبين",
  MandobSalesReport: "تقرير مبيعات مندوب",
  TasksReport: "تقرير المهام",
  ClientsWithBranch: "قائمة العملاء للفرع ",
  ClientsWithMandob: "قائمة العملاء للمندوب",
  ClientsWithNew: "قائمة العملاء الجدد",
  ClientsWithRegion: "قائمة العملاء للمنطقة",
  BranchSalesReport: "تقرير مبيعات فرع",
  BranchSalesReportShort: "تقرير مبيعات فرع مختصر",
  BranchSalesReportAllDetails: "تقرير مبيعات فرع مفصل",
  BranchMadioniaReport: "تقرير مديونية فرع",
  CompanyMadioniaReport: "تقرير مديونية شركة",
  CompanySalesReport: "تقرير مبيعات شركة",
  ItemSalesReport: "تقرير مبيعات صنف",
  ItemBuyReport: "تقرير مشتريات صنف",
  ItemClientTypeReport: "تقرير صنف بنوع العميل",
  MandobClientMadioniaReport: "تقرير مديونية عملاء بالمندوب",
  MandobClientSadadReport: "تقرير سداد عملاء بالمندوب",
  StoreItemTransferReport: "تقرير تحويلات صنف",
  StoreOneItemTransferReport: "تقرير تحويلات صنف للمخزن",
  StoreGardDetailReport: "تقرير جرد مخزن مفصل",
  KhazinaClientSadadReport: "تقرير سداد عملاء لخزنة",
  KhazinaInputReport: "تقرير خزنة",
  KhazinaInputDetailReport: "تقرير خزنة شامل",
  KhazinaImporterSadadReport: "تقرير سداد موردين لخزنة",
  EmployerSalaryReport: "تقرير مرتبات موظفين",
  EmployerOmolaReport: "تقرير عمولات موظفين",
  RebackClientReport: "تقرير مرتجع عملاء",
  RebackMandobReport: "تقرير مرتجعات لمندوب",
  RebackItemReport: "تقرير مرتجعات صنف",
  RebackItemBuyReport: "تقرير مرتج شراء لصنف",
  RebackImporterReport: "تقرير مرتجع شراء",
  MasrofAllReport: "تقرير جميع المصروفات",
  MasrofWithTypeReport: "تقرير بنوع المصروفات",
  RebackSellAll: "تقرير مرتجعات بيع شامل",
  RebackBuyAll: "تقرير مرتجعات بيع شامل",
  UserBehaviorReport: "تقرير تتبع الحركات للسيستم",
  StoreMovementReport: "تقرير حركة مخزن",
  StoreMovementAllReport: "تقرير لحركة المخازن",
  DashboardDetails: "الصفحات الداخلية",
  StoreOperationDetails: "صفحات المخازن",
  AccountDetails: "صفحات كشوف الحساب",
  BankDetails: "صفحات البنوك",
  BuyDetails: "صفحات الشراء",
  EmployerReportDetails: "صفحات تقارير الموظفين",
  HrDetails: "صفحات الادارة",
  ImporterReportDetails: "صفحات تقارير الموردين",
  KhazinaDetails: "صفحات الخزنة",
  KhazinaReportDetails: "صفحات تقارير الخزنة",
  ManageReportDetails: "صفحات تقارير الادارة",
  RebackReportDetails: "صفحات تقارير المبيعات",
  SalesDetails: "صفحات المبيعات",
  SalesReportDetails: "صفحات تقارير المبيعات",
  StorereportDetails: "صفحات تقارير المخازن",
  AddNewClient: "اضافة عميل جديد",
  mandobVisits: "زيارات مندوب",
  Tasks: "المهام",
  Tahsilat: "تحصيلات",
  Track: "التتبع",
  TaxFatwora: "الفواتير الضريبية"
};
